/**
 * メインエントリーポイント
 *
 * 旧 application/themes/modely/main.js の WP 移植版。
 * Babel/core-js/IE11対応は廃止。素のES2020+のまま出力する。
 */
import "../css/main.css";

import { initHeaderA } from "./modules/header-a.js";
import { initSmoothScroll } from "./modules/smooth-scroll.js";
import { initLightbox } from "./modules/lightbox.js";
import { initImageSlider } from "./modules/image-slider.js";
import { initSliderContent } from "./modules/slider-content.js";
import { initToc } from "./modules/toc.js";
import { initRegisterLead } from "./modules/register-lead.js";
import { initInquireForm } from "./modules/inquire-form.js";
import { initUtmCapture } from "./modules/utm-capture.js";

document.addEventListener("DOMContentLoaded", () => {
  // UTM / 広告パラメータの cookie 化はフォーム初期化より前に
  initUtmCapture();

  initHeaderA();
  initSmoothScroll();
  initLightbox();
  initImageSlider();
  initSliderContent();
  initToc();
  initRegisterLead();
  initInquireForm();
});
